import Meta from '@/components/common/Meta'

import ShipAndStorageNearMePage from '@/v2/components/pages/landing-pages/ship-and-storage-near-me-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/ship-and-storage-near-me-page'

interface ShipAndStorageNearMePageProps {}

const Page: React.FC<ShipAndStorageNearMePageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.ship_and_storage_near_me.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.ship_and_storage_near_me?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.ship_and_storage_near_me?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <ShipAndStorageNearMePage />
    </>
  )
}

export default Page
